import { inmunetApi } from '../../../api';

export const getAgenda = async(inicio, fin) => {

    try {

        const params = new URLSearchParams();
        if (inicio !== '--') {
            params.append('inicio', `${inicio}`);
        }
        if (fin !== '--') {
            params.append('fin', `${fin}`);
        }

        const { data } = await inmunetApi.get(`/agenda/index`, {
            params,
        });

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};